import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { checkOperatorPassword } from '../../utils/authUtils';
import { useTranslate } from '../../lib/i18n';

const Login = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const t = useTranslate();

  // Get the path the user was trying to access
  const from = location.state?.from?.pathname || '/training';
  const config = location.state?.config || '';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Simulate async behavior for better UX
    setTimeout(() => {
      if (checkOperatorPassword(password)) {
        // Store auth state in localStorage
        localStorage.setItem('isOperatorAuthenticated', 'true');
        // Redirect to the original destination
        navigate(from + (config ? `?config=${config}` : ''), { replace: true });
      } else {
        setError(t('login.invalidPassword'));
      }
      setIsLoading(false);
    }, 500); // Small delay to show loading state
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background text-foreground">
      <div className="w-full max-w-md rounded-lg border p-8">
        <h1 className="mb-6 text-2xl font-bold">{t('login.title')}</h1>

        {error && (
          <div className="mb-4 rounded border border-destructive bg-destructive/15 p-3 text-card-foreground">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="password" className="mb-2 block text-sm font-medium">
              {t('login.enterPassword')}
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-md border bg-input/25 p-2 text-foreground focus:border-ring focus:outline-none"
              required
              autoFocus
              disabled={isLoading}
              placeholder={t('login.placeholder')}
            />
          </div>

          <button
            type="submit"
            className="w-full rounded-md bg-secondary px-4 py-2 text-secondary-foreground hover:bg-secondary/90 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={isLoading || !password.trim()}
          >
            {isLoading ? t('login.verifyingButton') : t('login.loginButton')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
